<div class="e-scorecard-details">
    <i [class]="iconClass"></i>
    <h5>{{title}}</h5>
    <p>{{value}}</p>
</div>
